import { getEnvAsBoolean } from '@/utils/env'

// Feature flags and env-derived constants
export const DISPLAY_BALANCE_ON_LOAD = getEnvAsBoolean(
  'VITE_DISPLAY_BALANCE_ON_LOAD',
  false,
)
